module.exports = __webpack_public_path__ + "img/073637.e28560bf.png";